import React, { useContext, useEffect } from 'react';
import { Route, Switch, useHistory } from 'react-router-dom';
import { FundraiserForm } from './FundraiserForm';
import { FundraiserForm as FundraiserFormV2 } from './v2/FundraiserForm';
import { Fundraisers } from './Fundraisers';
import Registrations from './Registrations';
import { AdminContext } from '~/context/admin';
import { fundraiserV2Enabled } from '~/utils/fundraiserBeta';

export const FundraiserIndex = () => {
  const [{ isAdmin }] = useContext(AdminContext);
  return (
    <Switch>
      <Route exact path='/fundraisers' component={Fundraisers} />
      <Route exact path='/fundraisers/add' component={FundraiserForm} />
      <Route exact path='/fundraisers/edit/:id' component={FundraiserForm} />
      <Route
        exact
        path='/fundraisers/registrations/:id'
        component={Registrations}
      />
      {fundraiserV2Enabled(isAdmin) && (
        <>
          <Route exact path='/fundraisers/v2/add' component={FundraiserFormV2} />
          <Route exact path='/fundraisers/v2/edit/:id' component={FundraiserFormV2} />
        </>
      )}
    </Switch>
  );
};
